import { useNavigate } from "react-router-dom";

const useNavigateBasedOnPath = () => {
  const navigate = useNavigate();

  // Define restricted paths that should redirect to home
  const RESTRICTED_PATHS = [
    '/verification',
    '/login',
    '/signup',
    '/reset-password'
  ];

  const navigateBasedOnPath = () => {
    let prevPath = [];

    try {
      prevPath = JSON.parse(localStorage.getItem("pathHistory")) || [];
    } catch {
      localStorage.removeItem("pathHistory");
    }

    if (!Array.isArray(prevPath)) prevPath = [];

    const safePath = [...prevPath]
      .reverse()
      .find((path) => path && !RESTRICTED_PATHS.some((restrictedPath) => path.startsWith(restrictedPath)));

    navigate(safePath || '/');
  };

  return navigateBasedOnPath;
};

export default useNavigateBasedOnPath;
